<template>
  <v-card class="pa-3 mb-4">
    <v-row class="align-center">
      <v-col cols="auto">
        <status-filter
          :lock-to-active-inactive="false"
          condition-key="active"
          :status-list="statusOptions"
          :translator="translator"
          :filter-condition-getter="filterCondition"
          :filter-condition-setter="setFilterCondition"
        />
      </v-col>
      <v-col class="d-flex justify-end">
        <v-btn
          v-if="paymentLinksStore.isActive !== null"
          variant="text"
          color="primary"
          class="mr-3"
          @click="resetFilter"
        >
          {{ $t("page.payment.filter.clearFilters") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import i18n from "@/app/plugins/i18n";
import StatusFilter from "@/shared/components/Common/SearchFilter/StatusFilter.vue";
import { usePaymentLinksStore } from "@/payment-links/stores/paymentLinks";
import type { FilterCondition } from "@/shared/types/filters";

const paymentLinksStore = usePaymentLinksStore();
const statusOptions = computed(() => [
  { title: i18n.global.t("common.action.active"), value: "true" },
  { title: i18n.global.t("common.action.inactive"), value: "false" },
]);
const translator = {
  toStore: (value: string) => (value === "true" ? true : value === "false" ? false : undefined),
  fromStore: (value: unknown) => (value === true ? "true" : value === false ? "false" : ""),
  getLabel: (value: string) =>
    value === "true"
      ? i18n.global.t("common.action.active")
      : value === "false"
        ? i18n.global.t("common.action.inactive")
        : "",
};
const filterCondition = computed((): { value: FilterCondition } => ({
  value: paymentLinksStore.isActive === null ? {} : { active: paymentLinksStore.isActive },
}));
const setFilterCondition = (condition: FilterCondition) => {
  paymentLinksStore.setIsActive(
    condition.active === true ? true : condition.active === false ? false : null,
  );
};
const resetFilter = () => paymentLinksStore.setIsActive(null);
</script>
